import { ExamOverviewRow } from "../../interfaces/examInterfaces";
import { ITEM_EXISTS, NO_NAME, NO_SLASH_ALLOWED } from "../../texts";

export const createErrorText = (paths: Record<string, ExamOverviewRow[]> | null, pathString: string, name: string):string | null => {
    const trimmedName = name.trim()
    if (trimmedName === "") {
        return NO_NAME;
    }
    if (trimmedName.includes("/")) {
        return NO_SLASH_ALLOWED;
    }
    let exams = paths?.[pathString] ?? [];
    if (exams.map((exam: ExamOverviewRow) => exam.name).includes(trimmedName)) {
        return ITEM_EXISTS;
    }
    return null;
}
